import React from "react";
import styled from "styled-components";
import { useCurrentFrame } from "../use-current-frame";
import { spring } from "../Spring";
import { interpolate } from "../interpolate";
// import { interpolate } from "../interpolate";

const Container = styled.span`
    display: inline-flex;
    /* overflow: hidden; */
`;

const Holder = styled.span``;

function RiseAnimation(props) {
    const frame = useCurrentFrame();

    const { children, direction } = props;

    const opactiy = spring({
        frame: frame,
        fps: (props.videoConfig || {}).fps || 30,
        config: {
            damping: 200,
        },
    });

    function getTranslateValue() {
        if (direction === "up") {
            return 25;
        }
        return -25;
    }

    const translateY = interpolate(opactiy, [0, 1], [getTranslateValue(), 0]);

    return (
        <Container>
            <Holder
                style={{
                    opacity: opactiy,
                    transform: `translate(0px, ${translateY}px)`,
                }}
            >
                {children}
            </Holder>
        </Container>
    );
}

export default React.memo(RiseAnimation);
